import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { FeaturesSection } from './components/FeaturesSection';
import { ProcessSection } from './components/ProcessSection';
import { PricingSection } from './components/PricingSection';
import { InteriorAISection } from './components/InteriorAISection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-apple-black font-sans selection:bg-apple-blue selection:text-white relative overflow-hidden" data-id="element-0" data-mp="31bs1ff0jszn8">
      {/* Decorative background orbs */}
      <div className="gradient-orb w-[600px] h-[600px] bg-blue-300 top-[200px] -right-[200px] fixed" data-id="element-1" data-mp="28tw3qn4zwc1c" />
      <div className="gradient-orb w-[500px] h-[500px] bg-purple-300 top-[800px] -left-[200px] fixed" data-id="element-2" data-mp="23w4fc33k781w" />
      <div className="gradient-orb w-[400px] h-[400px] bg-emerald-200 top-[2000px] right-[100px] fixed" data-id="element-3" data-mp="3ikqz80j1f669" />

      <Navigation data-id="element-4" data-mp="3mkhn9wh6j873" />
      <main className="relative z-10" data-id="element-5" data-mp="3mjzu58ptda3e">
        <HeroSection data-id="element-6" data-mp="3rc9ca2kot5v4" />
        <TrustBar data-id="element-7" data-mp="3rbzn2h7gv2qh" />
        <div className="section-gradient-4" data-id="element-8" data-mp="3rdkhm6ts6loc">
          <InteriorAISection data-id="element-9" data-mp="3relwynhtxubv" />
        </div>
        <div className="section-gradient-1" data-id="element-10" data-mp="4wupmfw6qeo">
          <FeaturesSection data-id="element-11" data-mp="7su7f7e1n58" />
        </div>
        <div className="section-gradient-4" data-id="element-12" data-mp="2zlv6yuqqp1v2">
          <ProcessSection data-id="element-13" data-mp="2zn69yscd25l4" />
        </div>
        <div className="section-gradient-2" data-id="element-14" data-mp="33m5am0r27g6r">
          <PricingSection data-id="element-15" data-mp="33n6w6z5pbl2q" />
        </div>
        <div className="section-gradient-5" data-id="element-16" data-mp="38m1fs3bhtdnw">
          <TestimonialsSection data-id="element-17" data-mp="38l017ov9q91f" />
        </div>
        <div className="section-gradient-3" data-id="element-18" data-mp="3dkuwe4m2tksa">
          <FAQSection data-id="element-19" data-mp="3dlnu6g324zya" />
        </div>
      </main>
      <Footer data-id="element-20" data-mp="nvj53kddcmru" />
    </div>;
}